import { AnyAction } from "redux";
import { IFetchAction, FetchStatus } from "../middleware/fetch-middleware";

export enum EpiApiActions {
    GetEpiProps = 'epiApiActions/getEpiProps',
}

export interface EpiApiState<TProps> {
    props: TProps
}

const DefaultEpiApiState = {
    props: {}
}

export const epiApiReducerWithDefault = (defaultState: EpiApiState<any>) => (state = defaultState, action: AnyAction) => {
    switch (action.type) {
        case EpiApiActions.GetEpiProps + FetchStatus.Complete:
            return { ...state, props: action.data }
        default:
            return state;
    }
}

export const epiApiReducer = epiApiReducerWithDefault(DefaultEpiApiState);

const BaseUrl = '/api/v1/epi';

export const getEpiProps = (contentId: string): IFetchAction => ({
    type: EpiApiActions.GetEpiProps,
    fetch: new Request(`${BaseUrl}/properties?contentId=${contentId}`)
})